import LightTheme from './LightTheme';

// Other useful constants for styling
const mdWidth = 960; // medium screen width for css breakpoints

export { LightTheme, mdWidth };
